/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCommandDocumentAlarm {
    getFixupPrototypeFunction() { return AwsSsmCommandDocumentAlarm.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCommandDocumentAlarm>): AwsSsmCommandDocumentAlarm {
        let obj = Object.assign(new AwsSsmCommandDocumentAlarm(), model);
        AwsSsmCommandDocumentAlarm.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCommandDocumentAlarm>): AwsSsmCommandDocumentAlarm {
        if (!model) return null;
        return AwsSsmCommandDocumentAlarm.newInstance(<AwsSsmCommandDocumentAlarm> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCommandDocumentAlarm) {
        if (!obj) return;

        models.AwsSsmCommandDocumentAlarm.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCommandDocumentAlarm): boolean {
        Object.setPrototypeOf(obj, AwsSsmCommandDocumentAlarm.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The name of CloudWatch alarm.
     */
    name: string;

}
